<!-- A sortable list of MenuCategories.

Change via drag & Drop. Meant to be passed a copied list of
MenuCategories which we can modify here in-place, as a v-model.

-->

<template>
  <draggable
    v-model="sortableMenuCategories"
    v-bind="dragOptions"
    ghost-class="bg-info"
  >
    <transition-group
      type="transition"
      name="flip-list"
    >
      <div
        v-for="(category, categoryIndex) in sortableMenuCategories"
        :key="category.id"
      >
        <v-layout
          align-center
          class="clickable unselectable"
        >
          <div style="width: 64px">
            <v-btn icon>
              <v-icon color="grey darken-2">
                reorder
              </v-icon>
            </v-btn>
          </div>
          <div>
            <v-chip
              label
              class="grey lighten-3 subheading mx-0 outlined--dark"
              style="user-select: none; pointer-events: none"
            >
              {{ category.name }}
            </v-chip>
          </div>
        </v-layout>
        <v-divider
          v-if="categoryIndex < sortableMenuCategories.length - 1"
          :key="'divider-' + category.id"
        />
      </div>
    </transition-group>
  </draggable>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  components: {
    draggable,
  },
  props: {
    /* Implement default v-model to sync any changes. */
    value: {
      type: Array[Object],
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    sortableMenuCategories: {
      get() {
        return this.value;
      },
      // Implement default v-model to sync any changes.
      set(categories) {
        this.$emit('input', categories);
      },
    },
    dragOptions() {
      return {
        animation: 150,
        disabled: false,
      };
    },
  },
};
</script>

<style scoped>
.flip-list-move {
  transition: transform 0ms;
}
</style>



// WEBPACK FOOTER //
// src/components/Menu/SortableMenuCategories.vue